<form [formGroup]="form">
  <!-- Formulario para tipo de reporte -->
  <description-ras-type-of-report
    [(form)]="form"
  ></description-ras-type-of-report>
  <!-- Formulario para fechas -->
  <description-ras-date [(form)]="form"></description-ras-date>
  <!-- Formulario de moneda -->
  <description-ras-currency [(form)]="form"></description-ras-currency>

  <div class="row">
    <div class="col-12">
      <p class="text">45.{{ Texts.amount }}</p>
    </div>
    <div class="col-6">
      <mat-form-field appearance="outline">
        <mat-label>{{ Texts.credit }}</mat-label>
        <input Currency matInput formControlName="credit" />
      </mat-form-field>
    </div>
    <div class="col-6">
      <mat-form-field appearance="outline">
        <mat-label>{{ Texts.debit }}</mat-label>
        <input Currency matInput formControlName="debit" />
      </mat-form-field>
    </div>
  </div>

  <div>
    <p class="text">46.{{ Texts.description }}</p>
    <p class="hint">{{ Texts.descriptionHint }}</p>
    <mat-form-field appearance="outline">
      <textarea
        matInput
        formControlName="description"
        rows="5"
        cols="50"
      ></textarea>
    </mat-form-field>
    <div class="fileC">
      <!-- <mat-form-field (click)="addFile()" class="informe" appearance="outline">
        <mat-label>{{ Texts.file }} <span>*</span></mat-label>
        
       
      </mat-form-field> -->
      <button
        mat-button
        class="primary-btn rounded btnFile"
        (click)="addFile()"
        *ngIf="!file"
      >
        Agregar informe complementario
      </button>
      <!-- <input
        (click)="addFile()"
        *ngIf="!file"
        disabled
        matInput
        class="informe"
        [(ngModel)]="fileName"
      /> -->
      <div class="fileName" *ngIf="file">
        <p class="nameFile">{{ file.name }}</p>
      </div>
      <mat-icon *ngIf="file" class="iconSave" (click)="download()"
        >save</mat-icon
      >
      <mat-icon *ngIf="file" class="iconSave" (click)="deleteFile()"
        >delete</mat-icon
      >
    </div>
  </div>

  <div class="marginB">
    <other-person [(form)]="form"></other-person>
  </div>

  <div class="margin">
    <p class="text">48.Tipo de operación *</p>

    <!-- <mat-form-field appearance="outline">
      <mat-select formControlName="operationType">
        <mat-option
          *ngFor="let operation of operationTypes"
          [value]="operation"
        >
          {{ operation }}
        </mat-option>
      </mat-select>
    </mat-form-field> -->
    <div class="flex">
      <mat-form-field *ngIf="!form.value.check" appearance="outline">
        <mat-select formControlName="operationType">
          <mat-option
            *ngFor="let operation of operationTypes"
            [value]="operation"
          >
            {{ operation }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field
        *ngIf="form.value.check"
        style="width: 100%"
        appearance="outline"
      >
        <input
          type="text"
          formControlName="operationType"
          matInput
          placeholder="Escriba el tipo de caso"
        />
      </mat-form-field>
      <mat-checkbox class="check" formControlName="check">Otro</mat-checkbox>
    </div>
  </div>

  <div class="mt">
    <p class="text">
      49. Descripción del instrumento o producto asociado a la operación
      reportada*
    </p>
    <div class="row">
      <div class="col-6">
        <mat-form-field appearance="outline">
          <mat-label>{{ Texts.instrumentType }}</mat-label>
          <mat-select formControlName="instrumentType">
            <mat-option
              *ngFor="let instrumentType of instrumentsT"
              [value]="instrumentType"
            >
              {{ instrumentType }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-6">
        <mat-form-field appearance="outline">
          <mat-label>{{ Texts.instrumentNumber }} <span>*</span></mat-label>
          <input type="text" matInput formControlName="instrumentNumber" />
        </mat-form-field>
      </div>

      <div class="col-4">
        <mat-form-field appearance="outline">
          <mat-label>{{ Texts.agency }} <span>*</span></mat-label>
          <input type="text" matInput formControlName="agency" />
        </mat-form-field>
      </div>
      <div class="col-4">
        <mat-form-field appearance="outline">
          <mat-label>{{ Texts.openingDate }} <span>*</span></mat-label>
          <input type="date" matInput formControlName="openingDate" />
        </mat-form-field>
      </div>
      <div class="col-4">
        <mat-form-field appearance="outline">
          <mat-label>{{ Texts.deadline }} </mat-label>
          <input type="date" matInput formControlName="deadline" />
        </mat-form-field>
      </div>
    </div>
  </div>
  <!-- <div class="margin">
    <mat-form-field appearance="outline">
      <mat-label>{{ Texts.category }}</mat-label>
      <mat-select formControlName="category">
        <mat-option
          *ngFor="let category of riskCategorys"
          [value]="category.name"
          [matTooltip]="category.name"
          >{{ category.name }}</mat-option
        >
      </mat-select>
    </mat-form-field>
  </div> -->

  <div class="margin">
    <!-- <instrument-description [(form)]="form"></instrument-description> -->
    <others-instruments [(form)]="form"></others-instruments>
  </div>

  <div class="margin">
    <p class="text">51.{{ Texts.category }}</p>
    <mat-form-field appearance="outline">
      <mat-label>{{ Texts.category }}</mat-label>
      <mat-select formControlName="category">
        <mat-option
          *ngFor="let category of specialCategory"
          [value]="category"
          [matTooltip]="category"
          >{{ category }}</mat-option
        >
      </mat-select>
    </mat-form-field>
  </div>

  <div class="margin">
    <!-- <instrument-description [(form)]="form"></instrument-description> -->
    <others-instruments [(form)]="form"></others-instruments>
  </div>
</form>
